fragment ChatActionsFragment on Actions {
    chat {
        isConfigured
        label
        shouldCreateLeads
        shouldCreateLeadsPipelineId
    }
    booking {
        isConfigured
        label
        openingMessage
        meetingId
        formConfirmationMessage
        shouldCreateLeads
        shouldCreateLeadsPipelineId
    }
    email {
        isConfigured
        label
        openingMessage
        formSlug
        defaultFormSlug
        formConfirmationMessage
        shouldCreateLeads
        shouldCreateLeadsPipelineId
        shouldLinkEmailAddress
        linkEmailAddress
    }
    call {
        isConfigured
        label
        openingMessage
        formSlug
        defaultFormSlug
        formConfirmationMessage
        shouldCreateLeads
        shouldCreateLeadsPipelineId
        shouldLinkNumber
        linkNumberConfig {
            type
            customNumber
            callTrackerNumber
            callTrackerId
        }
    }
    text {
        isConfigured
        label
        openingMessage
        formSlug
        defaultFormSlug
        formConfirmationMessage
        shouldCreateLeads
        shouldCreateLeadsPipelineId
        shouldLinkNumber
        linkNumber
    }
    quote {
        isConfigured
        label
        shouldCreateLeads
        shouldCreateLeadsPipelineId
        openingMessage
        formSlug
        defaultFormSlug
        formConfirmationMessage
    }
}
